var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi-highlight-card"},[_c('div',{staticClass:"kpi-left"},[_c('h2',{staticClass:"kpi-number"},[_vm._v(_vm._s(_vm.animatedValue.toLocaleString()))]),_c('p',{staticClass:"kpi-label"},[_vm._v(_vm._s(_vm.title))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi-right"},[_c('div',{staticClass:"pulse-dot"})])
}]

export { render, staticRenderFns }